import { CustomerVariables } from "./variable_interfaces";

const TEST_ENV_BASEPATH = 'https://ecoreaction.wapice.com';
const PROD_ENV_BASEPATH = 'https://ecoreaction.wapice.com';
const LOCAL_AUTH = 'http://localhost:8080/auth';

export const defaultVariables: CustomerVariables = {
    realmName: 'EcoReaction',
    USER_SETTINGS_LINK: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : LOCAL_AUTH}` : PROD_ENV_BASEPATH + '/auth'}/realms/EcoReaction/account/#/personal-info`,
    KEYCLOAK_URL: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : LOCAL_AUTH}` : PROD_ENV_BASEPATH + '/auth'}/`,
    KEYCLOAK_BASE_PATH: `${process.env.REACT_APP_ENV !== 'production' ? `${process.env.REACT_APP_ENV === 'test' ? TEST_ENV_BASEPATH + '/auth' : '/auth'}` : PROD_ENV_BASEPATH + '/auth'}`,
    AUTHORIZATION_MAX_PERIOD_OF_VALIDITY_IN_YEARS: 2,
    LOGOUT_URL: `${process.env.REACT_APP_ENV !== 'production' && process.env.REACT_APP_ENV !== 'test' ? 'http://localhost:3001' : PROD_ENV_BASEPATH}`,
    KEYCLOAK_CLIENT_ID: 'representatives-end-user-ui',
    localizationLanguages: [
        {
            language: 'Finnish',
            languageAbbreviation: 'fi'
        }
    ],
    headerMenuLinks: [
        {
            buttonTitle: 'EcoReaction',
            buttonLink: 'https://ecoreaction.wapice.com/secured/reporting'
        }
    ]
}